export const app_json_content_type = 'application/json';

// search localStorage OR sessionStorage (in case user unchecks rememberMe option)
// The reason this works is because we are clearing the other storage when setting the token so we do not risk having
// stale tokens in the either storage.
export const getAuthToken = () => localStorage.getItem('token') || sessionStorage.getItem('token');

export const getRefreshToken = () =>
  localStorage.getItem('refreshToken') || sessionStorage.getItem('refreshToken');

export const getHeaders = (headerOpts = {}, contentType = app_json_content_type) => ({
  headers: {
    'Content-Type': contentType,
    Authorization: getAuthToken(),
    ...headerOpts,
  },
});

export const getFileHeaders = () => ({
  headers: {
    'Content-Type': 'application/zip',
    Authorization: getAuthToken(),
  },
});

export const getMultiPartHeaders = (additionalHeaderConfig = {}) => ({
  headers: {
    'Content-Type': 'multipart/form-data',
    Authorization: getAuthToken(),
    ...additionalHeaderConfig,
  },
});
